<!-- <template>
  <div class="login_bg">
    <img src="../../../static/index/logo.png" style="margin:80px 60px 0 100px" />
    <div class="login_top">
      <div class="login_box">
        <div class="login-logo">
          <h2>格瑞德智慧供应链平台</h2>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="forruleFormm" label-width="0 "
          style="    margin: 60px 30px 30px 30px;" size="large">
          <el-form-item prop="user">
            <el-input v-model="ruleForm.user" prefix-icon="el-icon-user" clearable placeholder="用户名">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="ruleForm.password" prefix-icon="el-icon-lock" clearable show-password
              placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 100%;margin-top:40px" :loading="islogin" round @click="login">登
              录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="login-footer">©2021 山东格瑞德集团有限公司版权所有</div>
  </div>
</template> -->

<script>
import Cookie from "js-cookie";
import { mapGetters, mapMutations } from "vuex";
import { cartCount } from "@/api/cart.js";
import { getVerify, loginWeb, registerID, getUserInfo } from "@/api/login.js";
import { async } from "q";
import { getNextPage,setNextPage } from '@/axios/cookies.js'
export default {
  name: "login",
    beforeRouteEnter (to, from, next) {
    next(vm => {
      const whiteList = [
        '/productDetail', // 商品明细
        '/indexpage/productlist', // 商品列表

      ]
      console.log(whiteList.indexOf(from.path),"indexOf");
      if (whiteList.indexOf(from.path) !== -1){
        console.log(from, 'from')
        setNextPage(from.fullPath)
      }
    })
  },
  data() {
    return {
      fromPath:"",
      ruleForm: {
        user: "",
        password: "",
      },
      regForm: {
        tel: "",
        code: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        user: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      regRules: {
        // pass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      islogin: false,
      show: "login",
      activeName: "pwdLogin",
      registerVisible: true,
      forgotVisible: true,
      loading: false,
      loading1: false,
      loading2: false,
      phoneNumber: null,
      phoneNumber1: null,
      phoneNumber2: null,
      authCode: null,
      authCode1: null,
      authCode2: null,
      pwd: "",
      pwd1: "",
      pwd2: "",
      pwdAgain: "",
      pwdAgain1: "",
      showTime: false,
      showTime1: false,
      showTime2: false,
      time: 60,
      time1: 60,
      time2: 60,
      timer: null,
      timer1: null,
      timer2: null,
      read: false,
      relus: /^1[13456789]\d{9}$/,
    };
  },
  created(){
    if(window.location.origin.includes('test.gradmall.cn') || window.location.origin.includes('localhost')){
      //测试环境
      window.open('http://testadmin.gradmall.cn/login', '_self')
    }else{
      //正式环境
      window.open('http://admin.gradmall.cn/login', '_self')
    }
  },
  computed: {
    ...mapGetters([
      "loginVisible", // 登录注册弹窗开关
    ]),
  },
  methods: {
    ...mapMutations({
      setUserInfo: "SET_USERINFO", // 修改用户信息
      setCartNum: "SET_CARTNUM", // 修改购物车商品数量
    }),
    // 倒计时
    countDown() {
      this.showTime = true;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          this.showTime = false;
          clearInterval(this.timer);
          this.time = 60;
        }
      }, 1000);
    },
    countDown1() {
      this.showTime1 = true;
      clearInterval(this.timer1);
      this.timer1 = setInterval(() => {
        if (this.time1 > 0) {
          this.time1--;
        } else {
          this.showTime1 = false;
          clearInterval(this.timer1);
          this.time1 = 60;
        }
      }, 1000);
    },
    countDown2() {
      this.showTime2 = true;
      clearInterval(this.timer2);
      this.timer2 = setInterval(() => {
        if (this.time2 > 0) {
          this.time2--;
        } else {
          this.showTime2 = false;
          clearInterval(this.timer2);
          this.time2 = 60;
        }
      }, 1000);
    },

    // 切换验证码登录
    codeLogin() {
      this.$message.warning("暂未接入短信登录");
      // this.activeName = 'codeLogin'
    },

    // 切换密码登录
    passwordLogin() {
      this.activeName = "pwdLogin";
    },

    // 登录获取验证码
    getCode() {
      if (this.ruleForm.phoneNumber === null) {
        return this.$message.warning("请输入手机号码");
      } else if (!this.relus.test(this.ruleForm.phoneNumber)) {
        return this.$message.warning("手机格式错误");
      }
      getVerify({
        phone: this.phoneNumber,
        type: "login", // bind绑定手机短信 login登陆短信 register注册短信
      }).then((res) => {
        if (res.status === 200) {
          this.$message.success("验证码发送成功");
          this.countDown();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 注册获取验证码
    getCode1() {
      if (this.regForm.tel === null) {
        return this.$message.warning("请输入手机号码");
      } else if (!this.relus.test(this.regForm.tel)) {
        return this.$message.warning("手机格式错误");
      }
      getVerify({
        phone: this.regForm.tel,
        type: "register",
      }).then((res) => {
        if (res.status === 200) {
          this.$message.success("验证码发送成功");
          this.countDown1();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    // 去注册
    toRegister() {
      this.show = "register";
    },

    // 忘记密码
    toForgot() {
      this.show = "forgot";
    },

    // 去登录
    toLogin() {
      this.show = "login";
    },

    // 登录
    login() {
      if (
        this.ruleForm.password.length < 4 ||
        this.ruleForm.password.length > 16
      ) {
        return this.$message.warning("请输入4至16位的密码");
      }
      this.loading = true;
      loginWeb({
        username: this.ruleForm.user,
        password: this.ruleForm.password,
      }).then(async (res) => {
        if (res.status === 200) {
          let seconds = res.data.expires_in;
          let expires = new Date(new Date() * 1 + seconds * 1000);
          Cookie.set("Yshop_token", res.data.token);
          Cookie.set("expires", expires);
          this.$message.success("登录成功");
          await this.getUserInfo();
          // this.$router.push({
          //     name: "/",

          //   });
          // this.getCartNum();
          // this.handleClose();
          // location.reload();
        } else {
          this.$message.warning("用户名或密码错误！");
        }
      });
      this.loading = false;
    },

    // 获取购物车商品数量
    async getCartNum() {
      var res = await cartCount();
      if (res.status === 200) {
        this.setCartNum(res.data.count);
      } else {
        this.$message.warning(res.msg);
      }
    },

    // 隐私协议是否已读
    select() {
      this.read = !this.read;
    },

    // 注册
    register() {
      if (!this.read) {
        return this.$message.warning("请先阅读YSHOP隐私条款");
      } else if (
        this.regForm.pass.length < 4 ||
        this.regForm.pass.length > 16
      ) {
        return this.$message.warning("请输入4到16位的密码");
      } else if (this.regForm.pass !== this.regForm.checkPass) {
        return this.$message.warning("两次密码不一致");
      }
      this.loading1 = true;
      registerID({
        account: this.regForm.tel,
        captcha: this.regForm.code,
        password: this.regForm.pass,
      }).then((res) => {
        if (res.status === 200) {
          this.$message.success("注册成功");
          setTimeout(() => {
            this.toLogin();
          }, 1000);
        } else {
          this.$message.warning(res.msg);
        }
      });
      this.loading1 = false;
    },

    // 修改密码
    getBack() {
      this.loading = true;
    },

    // 获取用户信息
    async getUserInfo() {
      var res = await getUserInfo();
      if (res.status === 200) {
        this.$store.commit("setLoginVisible", false);
        // this.$store.commit('setUser', res.data)
        // this.$store.commit('userInfo', res.data)
        // 登录信息存入内存中
        sessionStorage.setItem('SET_USER_INFO', JSON.stringify(res.data));
        this.$store.commit(
          "SET_USERINFO",
          res.data,
          new Date().getTime() + 3000
        );
        if(getNextPage()){
          this.$router.push(getNextPage())
        }else{
          this.$router.push("/indexpage/index")
        }
      }
    },

    // 关闭登录注册弹窗
    handleClose() {
      this.$store.commit("setLoginVisible", false);
    },
  },
};
</script>
<style scoped>
.login_bg {
  background: #fff;
  /* position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px; */
}




.login-logo {
  background: #fff;
  text-align: center;
  /* margin-bottom: 30px; */
}

.login-logo .logo {
  height: 70px;
  vertical-align: bottom;
}

.login-logo h2 {
  font-size: 24px;
  margin-top: 20px;
  color: #40485b;
}

.login-title {
  margin-top: 20px;
}

.login-title h2 {
  font-size: 22px;
  font-weight: normal;
}

.login-title p {
  font-size: 12px;
  margin-top: 40px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.8);
}

.login-form {

  width: 600px;
  padding: 60px 100px;
  background: #fff;
}

.login-footer {
  text-align: center;
  color: #999;
  margin-top: 100px;
}

.login_box {
  position: absolute;
  top: 30px;
  /* left: 0px; */
  right: 180px;
  bottom: 0px;
  width: 420px;
  height: 380px;
  background: #fff;
  box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.3);
  border-radius: 20px
}

.login_top {
  position: relative;
  background-image: url('../../../static/loginPic.jpg');
  background-size: 100% 100%;
  height: 450px;
  margin-top: 20px;
}</style>



// WEBPACK FOOTER //
// src/views/myLogin/index.vue